"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = _interopRequireDefault(require("../../index.js"));
var version = "v2";
var _default = exports["default"] = {
  get: function get(id, token) {
    var options = {
      headers: {
        Authorization: "Bearer ".concat(token)
      }
    };
    return _index["default"].get("/".concat(version, "/resources/").concat(id, "/"), token ? options : {});
  }
};